import { getApiBase } from './apiConfig';

export function logPageView(page) {
  fetch(`${getApiBase()}/analytics`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event: 'page_view', page, timestamp: new Date().toISOString() })
  });
}
